/**
 * @generated SignedSource<<5049c53c475bf710d8eb4ef97c67533e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useCoverPictureFragment_content$data = Result<{
  readonly coverPictureProperties: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useCoverPictureFragment_content";
}, unknown>;
export type useCoverPictureFragment_content$key = {
  readonly " $data"?: useCoverPictureFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCoverPictureFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useCoverPictureFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "coverPictureProperties",
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "cover-picture-id-draft",
            "cover-picture-id-published"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "concreteType": "Version",
              "kind": "LinkedField",
              "name": "version",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "number"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "42bffc5c08dfd5efc775bba301ca4d1b";

export default node;
